import React from 'react';
import { SpeciesVisual } from './SpeciesVisual';

export const SpeciesRightImage = ({ down_type, origin, t }) => {
  return (
    <SpeciesVisual down_type={down_type} origin={origin} lower="right" t={t} data-debug-id="species-right-image-visual" />
  );
};